import { formValidation } from "capitalrx-utilities";
import { Link, useAlert } from "capitalrx-components-2.0/lib/general";
import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CloseModalProp } from "@/api/interfaces/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Form, InputAlignmentContainer, Textbox } from "capitalrx-components-2.0/lib/forms";

import styles from "../styles.module.scss";

const EmailModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;
  const { email } = formValidation;
  const group_number = useGroupNumber();

  const showAlert = useAlert();

  const [requestCard] = useRequestDiscountCardMutation();

  const handleSubmit = async (payload: { discount_card_email: string }): Promise<void> => {
    await requestCard({
      request_type: 3,
      recipient: payload["discount_card_email"],
      group_number: group_number,
    })
      .unwrap()
      .then((data) => showAlert({ message: "Email sent. You should receive your discount card shortly.", type: "success", style: "toast" }))
      .catch((data) =>
        showAlert({ message: "Failed to email card. Please try again or contact customer support.", type: "error", style: "toast" }),
      );

    onClose();
  };

  return (
    <Form className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle} textAlign="center">Email Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle} textAlign="center">Enter your email address below to send this discount card.</Paragraph>
      <InputAlignmentContainer>
        <Textbox.Field
          validator={email}
          testId="test__discount_card_email"
          name="discount_card_email"
          placeholder="e.g., janedoe@address.com"
          required
        />
        <WhiteLabelSubmit classNames={styles.ModalFormSubmit} text="Send Email" />
      </InputAlignmentContainer>
      <Paragraph className={styles.ModalFormDisclaimer}>
        By submitting, I agree to the{" "}
        <Link to="https://cap-rx.com/legal" tooltip="Terms and privacy information">
          Privacy Policy &amp; Terms and Conditions
        </Link>
        .
      </Paragraph>
    </Form>
  );
};

export default EmailModal;
